import styled from '@emotion/styled'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { styles } from 'app/theme'
import { useParallax } from 'app/utils/customFunctions'
import { motion, useScroll } from 'framer-motion'
import React, { memo, useRef } from 'react'

export interface Props {
  image?: ImageProps
  index?: number
  isOdd?: boolean
  isVisible?: boolean
  languagePrefix?: string
  video?: string
}

export const Item = memo(function Item({
  image,
  index,
  isOdd,
  isVisible,
  languagePrefix,
  video,
}: Props) {
  const variants = {
    visible: {
      clipPath: 'inset(0)',
      transition: {
        delay: 0.6,
        duration: 1,
      },
    },
    hidden: {
      clipPath: index === 0 ? 'inset(0 0 100% 0)' : 'inset(100% 0 0)',
    },
  }

  const ref = useRef<any>()

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', '100vh'],
  })

  const y = useParallax(scrollYProgress, [-50, 50])

  return image ? (
    <Container
      className={`${isVisible ? 'visible' : ''}${isOdd ? ' odd' : ''}`}
      animate={isVisible ? 'visible' : 'hidden'}
      initial="hidden"
      ref={ref}
      variants={variants}
    >
      <Inner style={{ y }}>
        <Image {...image} />
      </Inner>
    </Container>
  ) : video ? (
    <Video
      className={isOdd ? 'odd' : undefined}
      aria-hidden="true"
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
    >
      <Source src={video} type="video/mp4" />
      Il tuo browser non supporta il video.
    </Video>
  ) : null
})

const Inner = styled(motion.div)`
  height: calc(100% + 6.25rem);
  position: relative;

  img {
    ${styles.img}

    transform: scale(1.3);
    transition: 2s ease-in-out;
  }

  @media (max-width: 1199px) {
    height: 100%;
    transform: none !important;
  }
`

const Container = styled(motion.div)`
  width: 23.333vw;
  overflow: hidden;
  &.visible {
    ${Inner} {
      img {
        transform: none;
      }
    }
  }
`

const Video = styled.video`
  object-fit: cover;
`

const Source = styled.source``
